// DB ENUM fr.gestionpial.pial.entities.RaisonSuppression generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping } from '@ic2/ic2-lib';

export class RaisonSuppression {
  static readonly enum: boolean = true;
  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.entities.RaisonSuppression';

  constructor(public id: number, public lib: string, public name: string) {
  }

  static readonly MANUEL = new RaisonSuppression(1, "Manuel", "MANUEL");
  static readonly NOUVELLE_REPARTITION = new RaisonSuppression(2, "Nouvelle répartition", "NOUVELLE_REPARTITION");

  static readonly values = [
    RaisonSuppression.MANUEL,

    RaisonSuppression.NOUVELLE_REPARTITION

  ];

  public toString(): string {
    return this.lib;
  }
  public static map(name: string) {
    for (const e of RaisonSuppression.values)
      if (e.name === name)
        return e;
    return null;
  }
  public static mapFromId(id: number) {
    for (const key of RaisonSuppression.values)
      if (key.id === id)
        return key;
    return null;
  }
}

mapping['fr.gestionpial.pial.entities.RaisonSuppression'] = RaisonSuppression;
